import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../../App/ModalCamposObligatorios'
function TablaPersonasAutorizadas(props) {

    const { api = undefined } = props
    let fc_36PersonasAutorizadasMap = props.productosMap
    let otrainstalacion = props.propia
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdle, handdleRemovePrev, handdleEditPrev, personaAutorizada, handdlePersonaAutorizadaBaja/*, handdlePersonaAutorizadaAlta*/ } = api
    const [id, setId] = React.useState()
    const [personaautoriazadaparatramites, setpersonaautoriazadaparatramites] = React.useState('')
    const [telefono, settelefono] = React.useState('')
    const [correoelectronico, setCorreo] = React.useState('')

    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = [
        {
            field: 'personaautoriazadaparatramites', headerName: 'Persona Autorizada', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:.7,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.personaautoriazadaparatramites}`} arrow>
                        <label>{`${params.row.personaautoriazadaparatramites} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'telefono', headerName: 'Teléfono', headerClassName: estilos.headerSolicitudes, headerAlign: 'center',flex:.5,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.telefono}`} arrow>
                        <label>{`${params.row.telefono} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'correoelectronico', headerName: 'Correo Electrónico', headerClassName: estilos.headerSolicitudes, headerAlign: 'center',flex:.8,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.correoelectronico}`} arrow>
                        <label>{`${params.row.correoelectronico} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex:.4,
            renderCell: (params) => (

                <Fragment>
                    {params.row.baja === null ?
                        <Fragment>

                            {fc_36PersonasAutorizadasMap?.length > 0 ? (
                                <Fragment>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                                </Fragment>)}
                        </Fragment>
                        : ((params.row.baja === false || params.row.baja === true) && params.row.isbaja === false) ?
                            <Fragment>
                                <button className={params.row.baja === false ? `btn btn-outline-warning ms-1` : params.row.baja === true ? `btn btn-danger ms-1` : ''} onClick={() => { botonBaja(params.row) }} >Dar de Baja</button>
                            </Fragment> :
                            {/*<Fragment>
                                <button className={(params.row.baja === false && params.row.alta === false) ? `btn btn-outline-warning ms-1` : (params.row.baja === false && params.row.alta === true) ? `btn btn-success ms-1` : ''} onClick={() => { botonAlta(params.row) }} >Dar de Alta</button>
                            </Fragment>*/}
                    }
                </Fragment>

            )
        },
    ]

    const botonEliminar = async (params) => {
        handdleRemovePrev({ data: params.row })
    }

    const botonGuardar = async () => {
        if (telefono.toString().length > 0 && correoelectronico.length > 0 && comprobarEmail(correoelectronico) && telefono.length == 10) {
            let dato = {
                id: id, personaautoriazadaparatramites: personaautoriazadaparatramites, telefono: telefono,
                correoelectronico: correoelectronico, alta: true, baja: null, isbaja: false
            }
            handdleEditPrev(dato)
            setpersonaautoriazadaparatramites('')
            settelefono('')
            setCorreo('')
            setEditar(false)
            setproductoMap([])
        } else {
            setvalidacion(true)
        }
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setpersonaautoriazadaparatramites(params.row.personaautoriazadaparatramites)
        settelefono(params.row.telefono)
        setCorreo(params.row.correoelectronico)
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(personaAutorizada)
    React.useEffect(() => {
        setRows(personaAutorizada)
    }, [personaAutorizada])

    const botonAgregar = async () => {
        if (telefono.toString().length > 0 && correoelectronico.length > 0 && comprobarEmail(correoelectronico) && telefono.length == 10) {
            let dato = {
                id: uuidv4(), personaautoriazadaparatramites: personaautoriazadaparatramites, telefono: telefono,
                correoelectronico: correoelectronico, alta: true, baja: null, isbaja: false
            }
            handdle(dato)
            setpersonaautoriazadaparatramites('')
            settelefono('')
            setCorreo('')
            setEditar(false)
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setpersonaautoriazadaparatramites('')
        settelefono('')
        setCorreo('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_36PersonasAutorizadasMap.filter(anexo => anexo?.idfc36_anexopersonasautorizadas === params.row.idfc36_anexopersonasautorizadas)
        setproductoMap(filtro[0])
        if (params.row.idfc36_anexopersonasautorizadas) setId(params.row.idfc36_anexopersonasautorizadas)
        else setId(params.row.idfc36_anexopersonasautorizadas)
        setpersonaautoriazadaparatramites(params.row.personaautoriazadaparatramites)
        settelefono(params.row.telefono)
        setCorreo(params.row.correoelectronico)
        setEditar(true)
    }
    const botonBaja = async (params) => {
        handdlePersonaAutorizadaBaja(params)
        //alert("se cambia")
    }
    /*const botonAlta = async (params) => {
        handdlePersonaAutorizadaAlta(params)
    }*/
    function comprobarEmail(correo) {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;

        if (correo.match(emailRegex)) {

            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }

        } else {
            return false
        }
    }
    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                value={personaautoriazadaparatramites} onChange={e => setpersonaautoriazadaparatramites(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Nombre completo</label>

                            {personaautoriazadaparatramites.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="number" min='0' className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                value={telefono} onChange={e => settelefono(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Teléfono</label>
                            {telefono.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> :
                                telefono.length != 10 ? <span className='text-danger'>Debe de contener 10 digitos</span> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                value={correoelectronico} onChange={e => {
                                    setCorreo(e.target.value)
                                    comprobarEmail(e.target.value)
                                }}
                            />
                            <label htmlFor='floatingInput'>Correo Electrónico</label>
                            {comprobarEmail(correoelectronico) == false ? <span className='text-danger'>Correo Invalido<br /></span> : <span className='text-success'>Correo Valido<br /></span>}
                            {correoelectronico.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                    </div>
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_36PersonasAutorizadasMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-4' onClick={botonAgregar}>Agregar persona autorizada</button>
                            </div>
                            <span className='text-start'><b className='text-danger'>Nota:</b>Si desea agregar una persona autorizada tildar botón Agregar persona autorizada.</span>

                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-4 ms-0'} onClick={botonGuardar}>Guardar persona autorizada</button>
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                        </div>
                        <br />
                    </Fragment>
                )
            }
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>

                <div className='col-12'><br />
                    <div style={{ height:  (130 + (rows?.length * 50)), width: '103%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />

                    </div><br />
                </div>
            </div>

        </>
    )

}
export default TablaPersonasAutorizadas